import { render, staticRenderFns } from "./ErrorPopup.vue?vue&type=template&id=6b108cba&scoped=true"
import script from "./ErrorPopup.vue?vue&type=script&lang=js"
export * from "./ErrorPopup.vue?vue&type=script&lang=js"
import style0 from "./ErrorPopup.vue?vue&type=style&index=0&id=6b108cba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b108cba",
  null
  
)

export default component.exports